import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { ChevronDown, ChevronRight } from "react-feather";
import {
  IWorkPipelineDevHistoryEntry,
  WORK_PIPELINE_DEV_STATUS_LABELS,
  WORK_PIPELINE_STAGE_LABELS,
} from "../../interfaces";

const describe = (entry: IWorkPipelineDevHistoryEntry): string => {
  if (entry.kind === "escalated") {
    return `Escalated to dev${
      entry.stage ? ` from ${WORK_PIPELINE_STAGE_LABELS[entry.stage]}` : ""
    }`;
  }
  const status = entry.status
    ? WORK_PIPELINE_DEV_STATUS_LABELS[entry.status]
    : "Status";
  return entry.stage ? `${status} → ${WORK_PIPELINE_STAGE_LABELS[entry.stage]}` : status;
};

/** Every escalation and dev status on a row, newest first; collapsed until asked for. */
export const DevHistory: React.FC<{
  history: IWorkPipelineDevHistoryEntry[];
}> = ({ history }) => {
  const [open, setOpen] = useState(false);
  if (!history.length) return null;
  return (
    <div className="mt-1">
      <Button
        size="sm"
        variant="link"
        className="p-0 small text-decoration-none"
        onClick={() => setOpen((o) => !o)}
        title="Every escalation to a dev and every dev status and comment on this domain, kept across hand-backs"
      >
        {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />} Dev
        history ({history.length})
      </Button>
      {open && (
        <ul className="list-unstyled small mb-0 mt-1 border-start ps-2">
          {[...history].reverse().map((entry, i) => (
            <li key={`${entry.at}-${i}`} className="mb-1">
              <span className="fw-semibold">{describe(entry)}</span>
              <span className="text-muted">
                {" "}
                · {entry.byName ?? "System"} ·{" "}
                {new Date(entry.at).toLocaleString()}
              </span>
              {entry.note && <div className="text-muted">{entry.note}</div>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
